import { siteConfig } from '@/lib/site'
import { cn } from '@/lib/utils'

/**
 * The VoxDiscover logo. The brand file (white letters, from voxdiscover.com) is built for dark
 * backgrounds; light mode gets a variant with the letters in the brand purple and a purple
 * hairline round the pills (public/brand/). Both are the same size, so the swap never shifts.
 */
export function Wordmark({ size = 'md', decorative = false }: { size?: 'sm' | 'md'; decorative?: boolean }) {
  const alt = decorative ? '' : siteConfig.name
  const height = size === 'md' ? 'h-6 sm:h-7' : 'h-5'
  return (
    <span className="inline-flex shrink-0">
      <img
        src="/brand/voxdiscover-logo-on-light.png"
        alt={alt}
        width={845}
        height={88}
        className={cn('w-auto dark:hidden', height)}
      />
      <img
        src="/brand/voxdiscover-logo-on-dark.png"
        alt={alt}
        width={845}
        height={88}
        className={cn('hidden w-auto dark:block', height)}
      />
    </span>
  )
}
